<div class="card">
    <p-toolbar class="mb-3" [style]="{ 'background-color': '#f3f4f6', border: '0' }">
        <ng-template pTemplate="start">
            <div class="font-semibold text-2xl mb-4">Schede Interventi</div>
        </ng-template>
        <ng-template pTemplate="end">
            <div class="flex items-center gap-2">
                <button pButton label="Nuovo intervento" icon="pi pi-plus" [size]="'large'" (click)="onNuovo()"></button>
                <button pButton label="Stampa/Esporta" icon="pi pi-download" severity="success" [size]="'large'" (click)="onExportCSV()"></button>
            </div>
        </ng-template>
    </p-toolbar>

    <p-table
        #dt
        [value]="records"
        [loading]="loading"
        dataKey="id"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 50]"
        [resizableColumns]="true"
        [responsiveLayout]="'stack'"
        breakpoint="1024px"
        [scrollable]="true"
        styleClass="p-datatable-striped p-datatable-sm"
        [tableStyle]="{ 'min-width': '1400px' }"
        [globalFilterFields]="['id', 'descrizioneIntervento', 'noteInterventoRilevatore', 'noteInterventoAssegnatore', 'dataInizioLavoro', 'dataVerifica', 'rilScSempliceId', 'rilScDoppiId', 'rilScIntDoppiId']"
    >
        <ng-template pTemplate="caption">
            <div class="flex justify-between items-center">
                <span class="text-sm text-500"></span>
                <span class="p-input-icon-left">
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca…" />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="dataInizioLavoro" style="width: 16rem">Inizio Lavoro <p-sortIcon field="dataInizioLavoro"></p-sortIcon></th>
                <th pSortableColumn="dataVerifica" style="width: 16rem">Verifica <p-sortIcon field="dataVerifica"></p-sortIcon></th>
                <th pSortableColumn="descrizioneIntervento">Descrizione <p-sortIcon field="descrizioneIntervento"></p-sortIcon></th>
                <th pSortableColumn="interventoGenericoFlg" style="width: 10rem">Interv. gen.</th>
                <th pSortableColumn="revisioneDeviatoioFlg" style="width: 11rem">Revisione dev.</th>
                <th pSortableColumn="sostituzioneDeviatoioFlg" style="width: 12rem">Sostituz. dev.</th>

                <th pSortableColumn="flgEsitoPositivo" style="width: 10rem">Esito +</th>
                <th pSortableColumn="flgEsitoNegativo" style="width: 10rem">Esito −</th>
                <th pSortableColumn="flgEsitoPositivoConRiserva" style="width: 14rem">+ con riserva</th>
                <!-- <th pSortableColumn="noteInterventoRilevatore">Note rilevatore</th>
                <th pSortableColumn="noteInterventoAssegnatore">Note assegnatore</th>
                <th style="width: 12rem">Anag. Deviatoio</th>
                <th style="width: 12rem">Tecnico rilevatore</th>
                <th pSortableColumn="rilScSempliceId" style="width: 10rem">Ril. Sc. Semp.</th>
                <th pSortableColumn="rilScDoppiId" style="width: 10rem">Ril. Sc. Doppi</th>
                <th pSortableColumn="rilScIntDoppiId" style="width: 12rem">Ril. Sc. Int. Doppi</th> -->
                <th style="width: 260px">Azioni</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-r>
            <tr [pSelectableRow]="r">
                <td>{{ formatDate(r.dataInizioLavoro) }}</td>
                <td>{{ formatDate(r.dataVerifica) }}</td>
                <td class="white-space-pre-wrap">{{ r.descrizioneIntervento }}</td>
                <!-- booleani con TAG -->
                <td><p-tag [value]="boolLabel(r.interventoGenericoFlg)" [severity]="boolSeverity(r.interventoGenericoFlg)" rounded></p-tag></td>
                <td><p-tag [value]="boolLabel(r.revisioneDeviatoioFlg)" [severity]="boolSeverity(r.revisioneDeviatoioFlg)" rounded></p-tag></td>
                <td><p-tag [value]="boolLabel(r.sostituzioneDeviatoioFlg)" [severity]="boolSeverity(r.sostituzioneDeviatoioFlg)" rounded></p-tag></td>

                <!-- esiti -->
                <td><p-tag [value]="boolLabel(r.flgEsitoPositivo)" [severity]="boolSeverity(r.flgEsitoPositivo)" rounded></p-tag></td>
                <td><p-tag [value]="boolLabel(r.flgEsitoNegativo)" [severity]="boolSeverity(r.flgEsitoNegativo)" rounded></p-tag></td>
                <td><p-tag [value]="boolLabel(r.flgEsitoPositivoConRiserva)" [severity]="boolSeverity(r.flgEsitoPositivoConRiserva)" rounded></p-tag></td>

                <!-- <td class="white-space-pre-wrap">{{ r.noteInterventoRilevatore || '-' }}</td>
                <td class="white-space-pre-wrap">{{ r.noteInterventoAssegnatore || '-' }}</td> -->

                <!-- relazioni -->
                <!-- <td class="white-space-pre-wrap">{{ renderRel(r.anagDeviatoio) }}</td>
                <td class="white-space-pre-wrap">{{ renderRel(r.tecnicoRilevatore) }}</td> -->

                <!-- <td>{{ r.rilScSempliceId ?? '-' }}</td>
                <td>{{ r.rilScDoppiId ?? '-' }}</td>
                <td>{{ r.rilScIntDoppiId ?? '-' }}</td> -->

                <td>
                    <div class="flex gap-2">
                        <button pButton icon="pi pi-pencil" [size]="'large'" severity="warn" (click)="onModifica(r)"></button>
                        <button pButton icon="pi pi-trash" [size]="'large'" severity="danger" (click)="onElimina(r)"></button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="18">Nessun intervento trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '450px' }" rejectButtonStyleClass="p-button-text" acceptLabel="Elimina" rejectLabel="Annulla" header="Confermi l'eliminazione?" icon="pi pi-exclamation-triangle"> </p-confirmDialog>
